import {setupForms} from '@fl/cmsch-fe-library';

import {FormStates} from 'app/setup';

const {
    useForm: appUseForm,
    formHelpers: appFormHelpers,
    formsReducer: appFormsReducer,
} = setupForms<FormStates>();

/** Hook for binding typed application forms to the shared form library helpers. */
export const useForm = appUseForm;

/** Redux action creators and selectors for the application's typed form state map. */
export const formHelpers = appFormHelpers;

/** Reducer that stores the application's typed form state map. */
export const formsReducer = appFormsReducer;
